export const environment = {
  production: false,
  BACKEND_URL: "https://dev-golem.sacra.game/api",
  MAIN_API_SERVER_URL: "https://dev-golem.sacra.game/api",
  CHAIN_ID: "1337",
  RPC_PROVIDER_URL: "https://dev-golem.sacra.game/rpc",
  SUBGRAPH_URI: "https://dev-golem.sacra.game/subgraphs/name/sacra",
  FORCE_GRAPH_URL: "https://dev-golem.sacra.game/subgraphs/name/sacra",
  USE_PROXY_SUBGRAPH: "false",
  backendDevAdminPassword: "123",
  STAGING: "true",
  MAINTENANCE: "false",
  USE_WEB_3_AUTH: "false",
  RELAY_SERVER: "",
  WAIT_FOR_SUBGRAPH: "0",
  ALCHEMY_API_KEY: "demo",
  WALLET_CONNECT_PROJECT_ID: "local",
  FIREBASE_API_KEY: "AIzaSyDUMMYLOCALONLY000000000000000000000",
  FIREBASE_AUTH_DOMAIN: "localhost",
  FIREBASE_PROJECT_ID: "sacra-local",
  FIREBASE_STORAGE_BUCKET: "sacra-local.appspot.com",
  FIREBASE_MESSAGING_SENDER_ID: "000000000000",
  FIREBASE_APP_ID: "1:000000000000:web:0000000000000000000000",
  FIREBASE_MEASUREMENT_ID: "G-0000000000",
};
